import { ChangeDetectionStrategy, Component, computed, inject, OnInit, signal } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { ModulesStore } from '../../../features/admin/modules/modules.store';
import type { Module } from '../../../features/admin/modules/modules.model';
import { FormHelper } from '../../../features/admin/modules/features/form-builder/form.util';
import { UserStore } from '../../../core/services/user.store';
import { canReadFieldRight, effectiveFieldRightForKeyPath } from '../../../features/admin/modules/field-rights.util';
import { cloneDeep } from 'lodash-es';

@Component({
  selector: 'formly-readonly-entry',
  template: `
    <div class="readonly-entry w-full float-left rounded-sm border p-4 pb-2 mb-2" [class]="field.props?.className">
      <formly-form [fields]="selectedReadonlyFields()" [model]="this.formControl.value"></formly-form>
      @if (field.props?.description) {
        <mat-hint class="inline-block mb-2">{{ field.props.description }}</mat-hint>
      }
    </div>
  `,
  imports: [
    ReactiveFormsModule,
    MatAutocompleteModule,
    FormlyModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
  ],
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldReadonlyEntry extends FieldType implements OnInit {
  modulesStore = inject(ModulesStore);
  userStore = inject(UserStore);
  module = signal<Module>(undefined);
  selectedReadonlyFields = computed(() => {
    const generatedForm = this.modulesStore.generatedForms()[this.module()?.id];
    return FormHelper.getFields(generatedForm)
      .filter(field => {
        return (
          this.field.props.readonlyFields?.includes(field.props.keyPath) &&
          canReadFieldRight(
            effectiveFieldRightForKeyPath(generatedForm, field.props.keyPath, this.userStore.currentUserRoles())
          )
        );
      })
      .map(field => {
        const fieldCopy = cloneDeep(field);
        fieldCopy.key = fieldCopy.props.keyPath;
        fieldCopy.props.disabled = true;
        return fieldCopy;
      });
  });

  constructor() {
    super();
  }

  ngOnInit() {
    this.module.set(this.modulesStore.getModuleByCode(this.field.props.linkedModule));
  }
}
